import React from 'react'
import ReactApexChart from 'react-apexcharts'

const ChartComponent = React.memo(
  ({ options, series, height, width, className, type }) => {
    return (
      <ReactApexChart
        options={options}
        series={series}
        type={type}
        height={height}
        width={width}
        className={className}
      />
    )
  },
  (prev, next) => prev.options === next.options && prev.series === next.series,
)

export default ChartComponent
